<div class="bar-chart-height bar-chart-width">
    <div *ngIf="this.barChartData1?.length > 0" echarts [options]="barChart" class="h-100"></div>
    <div *ngIf="this.barChartData1?.length == 0" class="text-center position">No data available</div>
</div>
